import { z } from "zod";

export const addOrgSchema = z.object({
  // شعار المؤسسة (صورة)
  logo: z.instanceof(File).optional(),

  // ── الخطوة الأولى ──────────────────────
  name: z.string().min(2, "يجب أن يحتوي الاسم على حرفين على الأقل"),
  code: z.string().min(2, "يجب أن يحتوي الرمز على حرفين على الأقل"),
  fees: z.string().min(1, "الرجاء إدخال مبلغ"),
  websiteUrl: z.string().url("الرابط غير صالح، الرجاء إدخال رابط صحيح"),
  description: z.string().max(500, "الوصف يجب ألا يتجاوز 500 حرف").optional(),

  // ── الخطوة الثانية ──────────────────────
  adminFirstName: z
    .string()
    .trim()
    .min(1, "الاسم الأول مطلوب")
    .max(50, "يجب ألا يزيد عن 50 حرفاً"),
  adminLastName: z
    .string()
    .trim()
    .min(1, "اسم العائلة مطلوب")
    .max(50, "يجب ألا يزيد عن 50 حرفاً"),
  email: z.string().email("يرجى إدخال بريد إلكتروني صالح"),
  // Full number with the calling code; checked against the country's phone rule in the step.
  mobile: z.string().min(1, "رقم الجوال مطلوب"),
});

export type AddOrgFormData = z.infer<typeof addOrgSchema>;
